@use '../../../components/custom-scroll/custom-scroll' as *;

@layer design-system {
  .styledSyntaxHighlighter {
    @include custom-scroll-minimal;
  }
}
